module.exports = __webpack_public_path__ + "img/Icon ionic-md-close.e081286d.svg";